import { useSelector } from "react-redux";
import { showFeature } from "../../lib/featureUtils";
import { key, trans } from "../../lib/utils";
import store from "../../stores/store";
import { getFeatureInfo } from "./mapUtils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

function MapGetPoints() {
  const mapGetPoints = useSelector(
    (state) => store.getState().map.mapGetPoints
  );

  const layers = useSelector((state) => store.getState().layers);
  const sources = useSelector((state) => store.getState().sources);

  const showPoint = (_coords, _projection) => {
    let feature = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: _coords,
      },
      projection: _projection,
      id: key(),
    };

    showFeature(feature);
  };

  return (
    <PerfectScrollbar className="scrollbar-recaclulate">
      <div className="me-3">
        {mapGetPoints.map((el, index) => {
          let idx = mapGetPoints.length - index;

          return (
            <div className="card mt-3 ">
              <div className="  me-2 mt-1 d-flex ps-3 pt-2" role="button">
                <span className="color-get-blue w-100">
                  {el.label.concat(idx)}
                </span>
                <i
                  className="fas fa-trash-alt color-black fa-sm"
                  onClick={() => {
                    store.dispatch({
                      type: "map/mapGetPoints/delete",
                      payload: index,
                    });
                  }}
                ></i>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="color-get-blue strong small">
                    {trans("Projection system")}: {el.projection}
                  </label>
                </div>
                <div className="mb-3">
                  <label className="color-get-blue strong small ">
                    {trans("Coordinates")}: {el.event.coordinate.join(" , ")}
                  </label>
                </div>

                <div className=" text-end">
                  <button
                    className="btn btn-white btn-sm border me-2"
                    onClick={() => {
                      getFeatureInfo(el.event, layers, sources, store);
                    }}
                  >
                    <span className="small">{trans("Get feature info")}</span>
                  </button>
                  <button className="btn btn-success btn-sm">
                    <span
                      className="text-white small"
                      onClick={() => {
                        showPoint(el.event.coordinate, el.projection);
                      }}
                    >
                      {trans("Show point")}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </PerfectScrollbar>
  );
}

export default MapGetPoints;
